import moment from 'moment';

import { CollectionPreview as API } from '@src/api/types';
import { generateMedia, generateUser } from '@src/factories';
import { CollectionPreview as Data } from '@src/types';

const Factory = (api: API): Data => ({
  id: api.id,
  cover: generateMedia(api.cover),
  title: api.title,
  creator: generateUser(api.creator),
  publishDate: moment(api.publishDate),
  status: api.status,
});

export default Factory;
